import type { ColumnSchema, Dataset, DatasetMeta, DatasetRow } from './types.ts';

/** Input shape for {@link createDataset}. */
export interface CreateDatasetInput {
  rows: readonly DatasetRow[];
  columns: readonly ColumnSchema[];
  meta?: DatasetMeta;
}

/**
 * Create a Dataset from rows and a column schema.
 *
 * This is a structural factory — it does not infer column types from row
 * values (see columns/infer-types.ts for that). Callers must provide a
 * complete column schema matching the shape of the rows.
 *
 * The returned Dataset omits `meta` entirely when none is provided, so
 * downstream code can rely on `'meta' in dataset` as a presence check.
 */
export function createDataset(input: CreateDatasetInput): Dataset {
  const { rows, columns, meta } = input;
  return {
    rows,
    columns,
    ...(meta === undefined ? {} : { meta }),
  };
}
